// extracted by mini-css-extract-plugin
export default {"placeholder":"index_placeholder__39kWC","feature":"index_feature__1yHhA","square":"index_square__l2l1J","poster":"index_poster__2XR4I","standard":"index_standard__2VwXn"};